module.exports = __webpack_public_path__ + "media/images/products/b5-ee0ebf26a2539e280e16d6a419f4ac70.png";